import { MenuLink, useStyles } from "./HeaderSubmenu";
import React, { useRef, useState } from "react";
import { ClickAwayListener, Paper, Popper } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { ListItem } from "app/components/common/ListItem";
import {
  SUBMISSIONS_PATH,
  TAKEOFF_PATH,
  usePerformanceAccess,
} from "app/routes/dashboard/routes/takeoff-performance/access";
export default function PerformanceMenu({ className, icon }) {
  const classes = useStyles();
  const anchor = useRef(null);
  const [open, setOpen] = useState(false);
  const { canView, canViewSubmissions, canViewMenu } = usePerformanceAccess();
  const { pathname } = useLocation();
  if (!canViewMenu) return null;
  return (
    <>
      <div ref={anchor}>
        <ListItem
          text="Performance"
          startAdornment={icon}
          underline
          selected={
            pathname.includes("/performance/") ||
            pathname.endsWith("/takeoff-performance")
          }
          className={className}
          onClick={() => setOpen((value) => !value)}
        />
      </div>
      <Popper
        open={open}
        anchorEl={anchor.current}
        placement="bottom-start"
        className={classes.popper}
      >
        <ClickAwayListener
          onClickAway={(event) => {
            if (!anchor.current?.contains(event.target)) setOpen(false);
          }}
        >
          <Paper className={classes.paper} elevation={4}>
            {canView && (
              <MenuLink
                to={TAKEOFF_PATH}
                label="Takeoff"
                active={
                  pathname === TAKEOFF_PATH ||
                  pathname.endsWith("/takeoff-performance")
                }
                onClick={() => setOpen(false)}
              />
            )}
            {canViewSubmissions && (
              <MenuLink
                to={SUBMISSIONS_PATH}
                label="Submissions"
                active={pathname === SUBMISSIONS_PATH}
                onClick={() => setOpen(false)}
              />
            )}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
